import { IOfferShipmentInput } from 'types/graphqlTypes'
import { TCoverModalSchema } from '../schema/CoverModalSchema'

export const prepareOfferInput = (
  shipmentId: string,
  data: TCoverModalSchema
): IOfferShipmentInput => {
  const { additionalCarrierInfo } = data

  return {
    shipmentId,
    carrierApplicationId: data.carrierApplicationId,
    carrierContactInstructions: additionalCarrierInfo ?? undefined,
    dispatcherId: data.carrierContactId,
    carrierRate: data.rate || 0,
    driverId: data.assignDriverTime === 'now' ? data.driverId : undefined,
    vin: data.vinNumber,
    truckNumber: data.truckNumber,
    ...(data.trailerNumber?.trim() ? { trailerNumber: data.trailerNumber } : {}), // Do not send trailer number if empty
  }
}
